import React, { useMemo } from 'react';
import { useModalWatch } from '../../../../shared/packages/modalManager';
import { modalNames } from '../../../../shared/configs/modal';
import { fieldNames } from '../../constants';
import { FormControllerProvider } from '../../../../../../helpers/formManager';

export const FormProvider = ({ children }) => {
  const clientId = useModalWatch({
    name: modalNames.attachmentsForm,
    selector: (state) => {
      return state?.props?.record?.client?.id;
    },
  });

  const options = useMemo(() => {
    return clientId
      ? { values: { [fieldNames.clientId]: clientId } }
      : undefined;
  }, [clientId]);

  return (
    <FormControllerProvider value={options}>{children}</FormControllerProvider>
  );
};
